import { OnInit, ElementRef, OnChanges, AfterViewInit } from '@angular/core';
import * as d3 from 'd3';
import { Partition } from 'src/app/shared/models/classes/simulation/partition';
import { FormatService } from 'src/app/shared/services/format.service';
import { UiService } from 'src/app/shared/services/ui.service';
import { IndiceModeType } from 'src/app/shared/models/enums/indice-mode-type.enum';
var CitizenPartitionChartComponent = /** @class */ (function () {
    function CitizenPartitionChartComponent(formatSrv, uiSrv) {
        this.formatSrv = formatSrv;
        this.uiSrv = uiSrv;
        this.colorsTree = [];
        this.partition = null;
        this.arc = null;
    }
    Object.defineProperty(CitizenPartitionChartComponent.prototype, "content", {
        set: function (content) {
            this.chartContainer = content;
        },
        enumerable: true,
        configurable: true
    });
    CitizenPartitionChartComponent.prototype.ngOnInit = function () {
    };
    CitizenPartitionChartComponent.prototype.ngAfterViewInit = function () {
        this.initChart();
    };
    CitizenPartitionChartComponent.prototype.ngOnChanges = function () {
        this.initChart();
    };
    CitizenPartitionChartComponent.prototype.initChart = function () {
        this.colors = this.uiSrv.getChartsColors();
        if (this.mainPartition) {
            this.setPartsColors(this.mainPartition.partitions);
            this.drawSunburst();
        }
        else {
            this.cleanUpChart();
        }
    };
    // create base chart objects with D3.js
    CitizenPartitionChartComponent.prototype.drawSunburst = function () {
        var element = this.chartContainer.nativeElement;
        this.cleanUpChart();
        this.radius = Math.min(element.offsetWidth, element.offsetWidth) / 2;
        var svg = d3.select(element).append("svg:svg")
            .attr("width", element.offsetWidth)
            .attr("height", element.offsetWidth);
        this.vis = svg.append("svg:g")
            .attr("id", "container")
            .attr("transform", "translate(" + element.offsetWidth / 2 + "," + element.offsetWidth / 2 + ")");
        this.partition = d3.layout.partition()
            .size([2 * Math.PI, this.radius * this.radius])
            .value(function (d) { return d.ratio * 100; })
            .children(function (d) { return d.partitions; })
            .sort(null);
        this.arc = d3.svg.arc()
            .startAngle(function (d) { return d.x; })
            .endAngle(function (d) { return d.x + d.dx; })
            .innerRadius(function (d) { return Math.sqrt(d.y) - 5; })
            .outerRadius(function (d) { return Math.sqrt(d.y + d.dy); });
        this.createVisualization();
    };
    // Main function to draw and set up the visualization, once we have the data.
    CitizenPartitionChartComponent.prototype.createVisualization = function () {
        var _this = this;
        var json = JSON.parse(JSON.stringify(this.mainPartition));
        var nodes = this.partition.nodes(json);
        // Bounding circle underneath the sunburst, to make it easier to detect
        // when the mouse leaves the parent g.
        this.vis
            .append("svg:circle")
            .attr("r", this.radius - this.radius * 0.32)
            .attr("id", "chart-bg")
            .style("opacity", 0);
        this.vis
            .append("svg:circle")
            .attr("r", this.radius - this.radius * 0.38)
            .attr("id", "text-bg")
            .style("opacity", 0);
        this.vis.data([json]).selectAll("path")
            .data(nodes)
            .enter().append("svg:path")
            .attr("display", function (d) { return (d.depth && d.isVisible) ? null : "none"; })
            .attr("d", this.arc)
            .attr("fill-rule", "inherit")
            .style("fill", function (d) { return _this.fillColor(d); });
        // .style('stroke', '#FFF');
        this.setActions();
    };
    // Manage mouseleave/mouseover handlers on circles.
    CitizenPartitionChartComponent.prototype.setActions = function () {
        var _this = this;
        this.vis.selectAll("path")
            .on("mouseover", function (d) { return _this.highlightPath(d); })
            .on("click", function (d) { return _this.highlightPath(d); });
    };
    // Set the color of each node
    CitizenPartitionChartComponent.prototype.fillColor = function (d) {
        var found = this.colorsTree.find(function (color) { return color.code === d.partitionDetails.code; });
        if (found) {
            return found.color;
        }
    };
    CitizenPartitionChartComponent.prototype.cleanUpChart = function () {
        var element = this.chartContainer.nativeElement;
        d3.select(element.querySelector('svg')).remove();
    };
    // Fade all but the current sequence.
    CitizenPartitionChartComponent.prototype.highlightPath = function (selected) {
        this.showedLabel = selected.partitionDetails.text ? selected.partitionDetails.text.shortLabel : "Text not found";
        if (this.mainPartition.mode === IndiceModeType.amount) {
            this.showedValue = this.formatSrv.formatAmount(100 * selected.ratio) + " €";
        }
        else {
            this.showedValue = this.formatSrv.formatPercent(selected.ratio) + " %";
        }
        this.vis.select("#chart-bg")
            .style("opacity", 1)
            .style("fill", this.fillColor(selected));
        this.vis.select("#text-bg")
            .style("opacity", 1)
            .style("fill", "#FFF");
        // Fade all the segments.
        this.vis.selectAll("path").style("opacity", 0.3);
        // this.vis.selectAll("path").style('stroke', '#FFF');
        // Then highlight only those that are an ancestor of the current segment.
        this.vis.selectAll("path")
            .filter(function (node) {
            var path = [];
            var current = selected;
            while (current.parent) {
                path.unshift(current);
                current = current.parent;
            }
            return (path.indexOf(node) >= 0);
        })
            .style("opacity", 1);
    };
    // Create gradient colors array to apply in chart for each partition
    CitizenPartitionChartComponent.prototype.setPartsColors = function (partitions, sendColor) {
        var _this = this;
        partitions.map(function (partition, index) {
            var color = sendColor || _this.colors[index];
            _this.colorsTree.push({
                code: partition.partitionDetails.code,
                color: color
            });
            if (partition.partitions && partition.partitions.length) {
                // const lighten = this.lightenHexColor(color, 10);
                _this.setPartsColors(partition.partitions, color);
            }
        });
    };
    return CitizenPartitionChartComponent;
}());
export { CitizenPartitionChartComponent };
